import { useEffect, useRef } from 'react';

function SoftBlob({ width = 300, height = 300 }) {
  const pathRef = useRef(null);
  const numPoints = 8;
  const baseRadius = 90;

  const offsets = useRef(
    Array.from({ length: numPoints }, () => Math.random() * Math.PI * 2)
  );

  useEffect(() => {
    let frame = 0;

    const animate = () => {
      const angleStep = (Math.PI * 2) / numPoints;
      const points = [];

      for (let i = 0; i < numPoints; i++) {
        const angle = i * angleStep;
        const offset = offsets.current[i];
        const variation = Math.sin(frame * 0.02 + offset) * 5;
        const radius = baseRadius + variation;
        const x = 100 + radius * Math.cos(angle);
        const y = 100 + radius * Math.sin(angle);
        points.push({ x, y });
      }

      let d = '';
      for (let i = 0; i < numPoints; i++) {
        const p0 = points[i];
        const p1 = points[(i + 1) % numPoints];
        const pMinus = points[(i - 1 + numPoints) % numPoints];
        const pPlus = points[(i + 2) % numPoints];

        const cp1x = p0.x + (p1.x - pMinus.x) * 0.2;
        const cp1y = p0.y + (p1.y - pMinus.y) * 0.2;
        const cp2x = p1.x - (pPlus.x - p0.x) * 0.2;
        const cp2y = p1.y - (pPlus.y - p0.y) * 0.2;

        if (i === 0) {
          d += `M ${p0.x} ${p0.y}`;
        }

        d += ` C ${cp1x} ${cp1y}, ${cp2x} ${cp2y}, ${p1.x} ${p1.y}`;
      }

      d += ' Z';

      if (pathRef.current) {
        pathRef.current.setAttribute('d', d);
      }

      frame++;
      requestAnimationFrame(animate);
    };

    animate();
  }, []);

  return (
    <svg viewBox="0 0 200 200" width={width} height={height}>
      <defs>
        <radialGradient id="blobGrad" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#0c419b" stopOpacity="0.6" />
          <stop offset="100%" stopColor="#0c419b" stopOpacity="1" />
        </radialGradient>
      </defs>
      <path
        ref={pathRef}
        fill="url(#blobGrad)"
        stroke="none"
      />
    </svg>
  );
}

export default SoftBlob;
